import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { useAuth } from '../../auth';

import { ORG_ID_CHOICE, ORG_ID_FETISH } from '../../api/choice';

export function ReserveButton({
    event,
    reservation = {},
    ...rest
}) {

    let { user } = useAuth();
    const navigate = useNavigate();

    const { allowRes } = event;
    const { membershipId } = reservation;

    let btn = null;

    //
    // If the user is logged in
    //
    if (user) {
        //
        // Check to see if the user is a member of the organization for this event
        //
        const memberOf = user.organizations.map((x) => x.id);
        const sponsor = event.organizationId;

        //
        // If the user is a member of the organization sponsoring the event
        //
        if (memberOf.includes(sponsor)) {
            // 
            // and the event allows reservations then show the create/edit buttons
            //
            if (allowRes === '1') {
                if (membershipId) {
                    btn = <Button {...rest}>Edit Reservation</Button>
                }
                else {
                    btn = <Button {...rest}>Reserve Now</Button>
                }
            }
        }
        else {
            if (sponsor === ORG_ID_CHOICE) {
                btn = <div>This event is only available for those with <b>swinger</b> memberships</div>
            }
            else if (sponsor === ORG_ID_FETISH) {
                btn = <div>This event is only available for those with <b>fetish</b> memberships</div>
            }
        }
    }

    //
    // The user is not logged in
    //
    else {
        btn = <Button onClick={() => navigate('#signin')}>Sign In</Button>;
    }

    return btn;
}   